import frenchTranslation from "./frenchTranslation.json";
import newTranslation from "./translation.json";
import quickRegisterFr from "./quickRegisterFr.json";
import registrationEn from "./Registration.json";
import forgotPasswordFr from "./forgotPasswordFr.json";
import resetPasswordFr from "./resetPasswordFr.json";
import changePasswordFr from "./changePasswordFr.json";

import quoteFr from "./quoteFr.json";
import orderLawyerInformationFr from "./orderLawyerInformationFr.json";
import propertyIdentificationFr from "./propertyIdentificationFr.json";
import purchasorMortgagorTabFr from "./purchasorMortgagorTabFr.json";
import lenderInformationFr from "./lenderInformationFr.json";
import additionalinformationFr from "./additionalInformationFr.json";
import menuFr from "./menuFr.json";
import orderSummaryFr from "./orderSummaryFr.json";
import viewOrdersFr from "./viewOrdersFr.json";
import inquiriesFr from "./inquiriesFr.json";
import PropertyTypesFr from "./PropertyTypesFr.json";
import autoAdjudicateFr from "./autoAdjudicateFr.json";
import orderStatusFr from "./orderStatusFr.json";
import downloadPoliciesFr from "./downloadPoliciesFr.json";
import accountSummaryFr from "./accountSummaryFr.json";
import orderInvoicesFr from "./orderInvoicesFr.json";
import fintracFr from "./fintracFr.json";
import QuotePropertyTypesFr from "./QuotePropertyTypesFr.json";

let translationFr = Object.assign(frenchTranslation, newTranslation);

Object.assign(
  translationFr,
  inquiriesFr,
  PropertyTypesFr,
  quickRegisterFr,
  registrationEn,
  forgotPasswordFr,
  resetPasswordFr,
  changePasswordFr,
  orderLawyerInformationFr,
  quoteFr,
  propertyIdentificationFr,
  purchasorMortgagorTabFr,
  lenderInformationFr,
  additionalinformationFr,
  menuFr,
  orderSummaryFr,
  viewOrdersFr,
  autoAdjudicateFr,
  orderStatusFr,
  downloadPoliciesFr,
  accountSummaryFr,
  orderInvoicesFr,
  fintracFr,
  QuotePropertyTypesFr
);

export default translationFr;
